import { render, staticRenderFns } from "./MahrumiyetInfo.vue?vue&type=template&id=6d0c677e"
import script from "./MahrumiyetInfo.vue?vue&type=script&lang=ts"
export * from "./MahrumiyetInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports